import { Box, Heading, Paragraph } from '@zillow/constellation-10';

import WizardTipCardContainer from '../../../../../srcLegacy/shared/components/WizardTipCardContainer';

import {
  wizardFlexContainerStyles,
  wizardFormSectionContainerStyles,
  wizardHeadingStyles,
  wizardParagraphStyles,
} from '../../../../styles/wizard';

import AllowContactByPhoneFormField from '../../../PostingPath/AllowContactByPhoneFormField';
import PageWizard from '../../../Wizard/PageWizard';

import type { WizardBodyTemplateProps } from '../../../WizardStepController';

const AllowContactByPhone = ({
  onGoToNextStep,
  onGoToPrevStep,
  onExitWizard,
  wizardTitle,
  progressStepper,
  totalSteps,
  currentStepIndex,
  showDesktopViewBreakpoint,
  ...rest
}: WizardBodyTemplateProps) => {
  return (
    <PageWizard
      {...rest}
      title=""
      wizardTitle={wizardTitle}
      progressStepper={progressStepper}
      totalSteps={totalSteps}
      currentStepIndex={currentStepIndex}
      onNextClick={onGoToNextStep || undefined}
      onBackClick={onGoToPrevStep || undefined}
      onExitTriggered={onExitWizard}
      showDesktopViewBreakpoint={showDesktopViewBreakpoint}
    >
      <div data-testid="AllowContactByPhone">
        <Box css={wizardFlexContainerStyles}>
          <Box css={wizardFormSectionContainerStyles.raw()}>
            <Heading level={2} textStyle="heading-sm" css={wizardHeadingStyles}>
              Do you want to allow renters to contact you by phone?
            </Heading>

            <Paragraph css={wizardParagraphStyles}>
              If you choose <strong>No</strong>, the listing will display without a phone number.
            </Paragraph>

            <Paragraph css={wizardParagraphStyles}>
              To protect your information, the number displayed on your listing differs from your actual number.
            </Paragraph>

            <AllowContactByPhoneFormField />
          </Box>

          <WizardTipCardContainer header="How is my number used?" showDesktopViewBreakpoint={showDesktopViewBreakpoint}>
            <Paragraph>
              We’ll assign your listing a random number that will automatically route incoming calls to your phone. It’s
              up to you to share your number directly with an applicant.
            </Paragraph>
          </WizardTipCardContainer>
        </Box>
      </div>
    </PageWizard>
  );
};

export default AllowContactByPhone;
